import { useEffect, useState } from "react";
import { Download, X, Share, PlusSquare } from "lucide-react";

const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export default function InstallPrompt({ accent = "#006D5B" }) {
  const [deferred, setDeferred] = useState(null);
  const [hidden, setHidden] = useState(isStandalone());
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => setHidden(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (hidden || !isIOS) return null;

  const onClick = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
    } else {
      setShowIOS(true);
    }
  };

  return (
    <>
      <button
        data-testid="install-app-btn"
        onClick={onClick}
        style={{ backgroundColor: accent }}
        className="fixed bottom-5 right-5 z-50 flex items-center gap-2 text-white font-semibold text-sm px-5 py-3 rounded-full shadow-2xl hover:-translate-y-0.5 transition-transform duration-200"
      >
        <Download size={16} /> Install App
      </button>

      {showIOS && (
        <div data-testid="ios-install-modal" className="fixed inset-0 z-[60] bg-black/50 flex items-end sm:items-center justify-center p-4">
          <div className="bg-white rounded-3xl p-7 max-w-sm w-full relative">
            <button
              data-testid="ios-install-close-btn"
              onClick={() => setShowIOS(false)}
              className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center"
            >
              <X size={16} />
            </button>
            <h3 className="font-heading font-bold text-xl mb-1">iPhone pe install karo</h3>
            <p className="text-sm text-gray-500 mb-5">Safari mein 3 simple steps:</p>
            <ol className="space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <span style={{ backgroundColor: accent }} className="w-7 h-7 shrink-0 rounded-full text-white text-xs font-bold flex items-center justify-center">1</span>
                <span className="flex items-center gap-1.5">Neeche <Share size={15} className="inline text-blue-500" /> <strong>Share</strong> button dabao</span>
              </li>
              <li className="flex items-center gap-3">
                <span style={{ backgroundColor: accent }} className="w-7 h-7 shrink-0 rounded-full text-white text-xs font-bold flex items-center justify-center">2</span>
                <span className="flex items-center gap-1.5"><PlusSquare size={15} className="inline" /> <strong>"Add to Home Screen"</strong> chuno</span>
              </li>
              <li className="flex items-center gap-3">
                <span style={{ backgroundColor: accent }} className="w-7 h-7 shrink-0 rounded-full text-white text-xs font-bold flex items-center justify-center">3</span>
                <span>Upar right mein <strong>"Add"</strong> dabao — ho gaya! 🎉</span>
              </li>
            </ol>
          </div>
        </div>
      )}
    </>
  );
}
